import NotificationContent from 'Components/Notifications/NotificationContent'
import React from 'react'
import ReactModal from 'react-modal'
import useIsMobile from 'Hooks/useIsMobile';

// Notifications for one case (from "Search by case ID")
function NotificationsModal({caseNumber, notificationsList, uploadNew, onClose, attorney}) {
  const isMobile = useIsMobile();
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30,
          backgroundColor: 'rgba(20,33,61,.45)'
        },
        content: {
            height: 'auto',
            maxHeight: '85vh',
            width: isMobile ? 'calc(100% - 24px)' : '760px',
            maxWidth: '100%',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: 0,
            border: 'none',
            borderRadius: '8px',
            background: '#f7f4ed',
            boxShadow: '0 20px 50px rgba(20,33,61,.25)',
        }
      }}
    >
        <div className='flex items-center justify-between bg-white font-plexsans' style={{ padding: '18px 28px', borderBottom: '1px solid rgba(20,33,61,.1)' }}>
          <div style={{ font: "400 19px/1.3 'Spectral',serif", color: '#14213d' }}>Notifications for {caseNumber}</div>
          <span onClick={onClose} className='cursor-pointer hover:text-navy' style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(20,33,61,.5)' }}>Close</span>
        </div>
        <div style={{ padding: '20px 28px 24px' }}>
          <NotificationContent
            isNotificationSearch={true}
            notificationArr={notificationsList}
            caseNumber={caseNumber}
            attorney={attorney}
          />
        </div>
    </ReactModal>
  )
}

export default NotificationsModal
